// components/BalanceCell.js
import {memo} from "react";

export const BalanceCell = memo(({balance}) => {
    const numBalance = parseFloat(balance) || 0;
    const isPositive = numBalance > 0;
    const isNegative = numBalance < 0;

    return (
        <span style={{
            fontSize: '16px',
            fontWeight: "bold",
            fontFamily: 'monospace',
            color: isPositive ? '#389e0d' : isNegative ? '#cf1322' : '#8c8c8c'
        }}>
            {isPositive ? '+' : ''}{numBalance.toFixed(2)} €
        </span>
    );
});

BalanceCell.displayName = 'BalanceCell';